import { t } from 'i18next'
import React, { useContext, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AccessContext from '../../context/AccessContext/AccessContext';
import AccessVehiclesContext from '../../context/AccessVehiclesContext/AccessVehiclesContext';
import ButtonBlackReturn from '../Buttons/ButtonBlackReturn';
import { ButtonBlue } from '../Buttons/ButtonBlue';
import { replaceExpecialCharacters } from '../../helpers/helpers';

const VisitForm = () => {

    const { accessState, setVisit, setStep, clean } = useContext(AccessContext);
    const { visit } = accessState;

    const { cleanAccessVehiclesState } = useContext(AccessVehiclesContext);

    const { identificator } = useParams();

    const initialStateForm = visit !== null ? visit : { document: identificator, full_name: '', reason: '' };

    const [visitData, setVisitData] = useState(initialStateForm)

    const navigate = useNavigate();

    const disabled = !!!String(visitData.full_name).trim() || !!!String(visitData.reason).trim();

    const handleChange = (e) => {
        const { value, name } = e.target;
        setVisitData({
            ...visitData,
            [name]: replaceExpecialCharacters(value)
        })
    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (disabled) return
        setVisit(visitData);
        setStep('ACCESS_WITH');
    };

    const handleGetBack = () => {
        navigate('/dashboard');
        clean();
        cleanAccessVehiclesState();
    }

    return (
        <form className='d-flex flex-column justify-content-between h-100' onSubmit={onSubmit}>
            <div className='d-flex flex-column gap-4 '>
                <div>
                    <label
                        htmlFor="document"
                        className='form-label blue-dark-text'
                    >
                        {t('DOC')}
                    </label>
                    <input
                        className='form-control'
                        type="text"
                        name='document'
                        value={visitData.document}
                        onChange={handleChange}
                        disabled
                    />
                </div>
                <div>
                    <label
                        htmlFor="full_name"
                        className='form-label blue-dark-text'
                    >
                        {t('FULL_NAME')}
                    </label>
                    <input
                        className='form-control'
                        type="text"
                        name='full_name'
                        value={visitData.full_name}
                        onChange={handleChange}
                        maxLength={70}
                        placeholder={t('ENTER_FULL_NAME_OF_VISIT')}
                    />
                </div>
                <div>
                    <label
                        htmlFor="reason"
                        className='form-label blue-dark-text'
                    >
                        {t('VISIT_REASON')}
                    </label>
                    <input
                        className='form-control'
                        type="text"
                        name='reason'
                        value={visitData.reason}
                        onChange={handleChange}
                        maxLength={255}
                        placeholder={t('ENTER_VISIT_REASON')}
                    />
                </div>
            </div>
            <div className='d-flex justify-content-between align-items-center mt-4 mb-4'>
                <div className="w-75">
                    <ButtonBlackReturn
                        title={t('GET_BACK')}
                        onClick={handleGetBack}
                    />
                </div>
                <div className="w-50">
                    <ButtonBlue
                        className='w-100'
                        type='submit'
                        disabled={disabled}
                    >
                        {t('NEXT')}
                    </ButtonBlue>
                </div>
            </div>
        </form>
    )
}

export default VisitForm